<template>
  <b-loading v-if="loading" active></b-loading>
  <div v-else>
    <post-preview v-for="post in posts" :key="post.id" :post="post"></post-preview>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { DataStore } from 'aws-amplify'
import { Post } from '@/models'
import PostPreview from '../posts/preview'
export default {
  components: {
    PostPreview
  },
  data () {
    return {
      loading: 0,
      posts: []
    }
  },
  computed: mapState([ 'profile' ]),
  async created () {
    this.loading++
    try {
      const profileID = this.profile.id
      this.posts = await DataStore.query(Post, q => q.profileID('eq', profileID))
    } catch (e) {
      console.warn(e)
    }
    this.loading--
  }
}
</script>
